import styled, { css } from 'styled-components';

import {
    compose,
    space,
    layout,
    color,
    flexbox,
    grid,
    background,
    border,
    position,
    shadow,
    typography,
    LayoutProps,
    SpaceProps,
    FlexboxProps,
    GridProps,
    BackgroundProps,
    BorderProps,
    PositionProps,
    ShadowProps,
    ColorProps,
    TypographyProps,
    system,
} from 'styled-system';
import pseudoStyle from '../../utils/pseudoStyle';

const themeKeys = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    boxShadow: 'shadows',
    cursor: 'pointer',
};

export interface BoxProps
    extends SpaceProps,
        LayoutProps,
        ColorProps,
        FlexboxProps,
        GridProps,
        BackgroundProps,
        BorderProps,
        PositionProps,
        ShadowProps,
        TypographyProps {
    gap?: string;
    placeItems?: string;
    placeContent?: string;
    userSelect?: string;
    transform?: string;
    transformOrigin?: string;
    cursor?: string;
    pointerEvents?: string;
    _hover?: typeof themeKeys;
}

const hover = pseudoStyle({
    prop: '_hover',
    pseudoclass: 'hover',
    keys: themeKeys,
});

const Box = styled.div<BoxProps>`
    ${compose(
        color,
        flexbox,
        background,
        border,
        position,
        shadow,
        typography,
        system({
            transform: true,
            transition: true,
            cursor: true,
            transformOrigin: true,
            pointerEvents: true,
            whiteSpace: true,
            gap: true,
            marginInlineStart: true,
            marginInlineEnd: true,
            paddingInlineStart: true,
            paddingInlineEnd: true,
            boxSizing: true,
            listStyle: true,
            userSelect: true,
            placeItems: true,
            placeContent: true,
            scrollMarginTop: true,
        }),
        grid,
        space,
        layout
    )}
    ${hover}
`;

export default Box;
